import { ParentModule } from './../../../A2-utils/ParentClass/parent-module';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, Injector } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { GridOptions, RowNode } from 'ag-grid';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { constant } from '../../../../app.constants';
import { RiderPayorDetailService } from '../../../../core/services/rider-payor-detail.service';
import { PlanService } from '../../../../core/services/plan.service';
import { PlanInterface } from '../../../../core/interfaces/plan.interface';
import { IResponseSuccess, ResponseInterface } from '../../../../core/interfaces/response.interface';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs/Subscription';
import { FileModel } from './rider-payor-detail.models';
import { CustomDate } from 'app/core/helpers/format-date-helper';

@Component({
  selector: 'app-rider-payor-detail',
  templateUrl: './rider-payor-detail.component.html',
  styleUrls: ['./rider-payor-detail.component.scss']
})
export class RiderPayorDetailComponent extends ParentModule implements OnInit, OnDestroy  {

  @Input() riderPayorForm: FormGroup;
  @Input() inactiveInput: boolean;
  @Output() idRider: EventEmitter<any>= new EventEmitter<any>();

  @ViewChild('riderPayorDetailT2Card') riderPayorDetailT2Card: T2CardComponent;
  protected grid: GridOptions;
  protected form: FormGroup;
  protected maskDate = constant.MASK_DATE_DMY;
  protected selectPlan: PlanInterface[];
  protected json = {
    riderpayordetailid: '',
    riderpayorid: '',
    groupid: '',
    startdate: '',
    expirationdate: '',
    planid: null,
    isltc: false,
    tripsqty: null,
    description: null,
    createdon: '',
    modifiedonformatted: ''
  };
  file: FileModel = new FileModel();
  private rowIndex: number;
  subscriptions: Subscription[] = [];
  fileName: string;

  constructor(
    private fb: FormBuilder,
    private _riderPayorDetailService: RiderPayorDetailService,
    private _planService: PlanService,
    private sweetAlertHelper: SweetAlertHelper,
    protected Inject: Injector
  ) {
    super('app-rider-payor-detail', Inject);
    this.grid = <GridOptions>{
      columnDefs: this.columnDefs(),
      rowSelection: 'multiple',
      enableSorting: true,
      enableFilter: true,
      enableColResize: true
    };
    this.grid.onGridReady = () => {
      this.grid.api.sizeColumnsToFit();
    };
  }

  get riderPayorDetailIdCtrl(): AbstractControl {
    return this.form.get('riderpayordetailid');
  }

  get tripsqtyCtrl(): AbstractControl {
    return this.form.get('tripsqty');
  }

  get validateExpirationdate(): boolean {
    return !this.dateParse(this.form.get('expirationdate').value);
  }

  get validateStartdate(): boolean {
    return !this.dateParse(this.form.get('startdate').value);
  }

  get validateButtonSave(): boolean {
    return !this.form.valid || this.validateDate(false);
  }

  get riderPayorDetailFormArray(): FormArray {
    return this.riderPayorForm.get('riderpayordetails') as FormArray;
  }

  get validateAction(): boolean {
    return this.riderPayorDetailIdCtrl.value && this.isAllowedAction('UpdateTripsQty');
  }

  ngOnInit() {
    this.form = this.addFbGroup(this.json);
  }

  add() {
    this.valueChanges();
    this.riderPayorDetailT2Card.open();
  }


  removeWithConfirmation() {
    const selectedRows = this.grid.api.getSelectedNodes();
    if (!selectedRows || !selectedRows.length) {
      this.sweetAlertHelper.createCustomAlert({
        title: 'You must select at least one record.',
        type: 'warning',
      });
    return;
  }
    const count = selectedRows.length;

    this.sweetAlertHelper
      .createCustomAlert({
        title: 'Delete Records',
        text: `Are you sure you want to delete the ${count} selected record${count > 1 ? 's' : ''}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete',
      })
      .then((result) => {
        if (result && result.value) {
          this.remove();
        }
      });
  }

  getSelectNodeAfterFilter = (agGrid: GridOptions): any[] => {
    const row: any[] = [];
    agGrid.api.forEachNodeAfterFilter((node: RowNode) => {
      if (node && node.isSelected()) {
        row.push(node.data);
      }
    });
    return row;
  }


  remove() {
    const rowSelect = this.getSelectNodeAfterFilter(this.grid);
    const rowsToDeleteFromBackend = rowSelect.filter(
      (r) => r.riderpayordetailid && r.riderpayorid
    );
    const idsToDelete: number[] = rowsToDeleteFromBackend.map(
      (r) => r.riderpayordetailid
    );
    if (rowsToDeleteFromBackend && rowsToDeleteFromBackend.length) {
      this._loading.show();
      this.subscriptions.push(
        this._riderPayorDetailService.delete(idsToDelete)
          .finally(() => this._loading.hiden())
          .subscribe(
            (resp: IResponseSuccess) => {
              this.responseSuccess(resp).then(() => {
                rowsToDeleteFromBackend.forEach(r => {
                  const index = this.riderPayorDetailFormArray.controls.findIndex(
                    c => c.value.riderpayordetailid === r.riderpayordetailid
                  );
                  if (index !== -1) {
                    this.riderPayorDetailFormArray.removeAt(index);
                  }
                });
                this.idRider.emit(true);
              });
            },
            (error: ResponseInterface) =>
              this.sweetAlertHelper.captureException(error)
          )
      );
    }
  }

  save() {
    const value = this.form.value;
    const rowIndex = this.rowIndex;
    if (this.form.get('riderpayordetailid').value) {
      this.subscriptions.push(
        this._riderPayorDetailService.put(value).subscribe((resp: IResponseSuccess) => {
          this.responseSuccess(resp).then(() => {
            this.idRider.emit(true);
            this.riderPayorDetailFormArray.at(rowIndex).patchValue(value);
          });
        }, (error: ResponseInterface) => this.sweetAlertHelper.captureException(error))
      );
    } else {
      if (this.form.get('riderpayorid').value) {
        this.subscriptions.push(
          this._riderPayorDetailService.post(value).subscribe({
            next: (resp: IResponseSuccess) => {
              if (resp) {
                this.responseSuccess(resp).then(() => {
                  resp.data['startdate'] = resp.data['startdateformatted'];
                  resp.data['expirationdate'] = resp.data['expirationdateformatted'];
                  this.riderPayorDetailFormArray.push(this.addFbGroup(resp.data));
                  this.idRider.emit(true);
                });
              }
            },
            error: (error) => {
              this.sweetAlertHelper.captureException(error);
            },
          })
        );
      } else {
        if (rowIndex != undefined) {
          this.riderPayorDetailFormArray.removeAt(rowIndex);
        }
        this.riderPayorDetailFormArray.push(this.addFbGroup(value));
      }
    }
    this.form.patchValue(this.json);
    this.riderPayorDetailT2Card.close();
  }

  responseSuccess(resp: IResponseSuccess) {
    return this.sweetAlertHelper.createCustomAlert(
      {
        title: 'Success',
        text: resp.message,
        type: 'success'
      });
  }

  addFbGroup(json: any) {
    const data = json || {};

    return this.fb.group({
      riderpayordetailid: [data.riderpayordetailid || null],
      riderpayorid: [data.riderpayorid || null],
      groupid: [data.groupid || null],
      startdate: [data.startdate || null],
      expirationdate: [data.expirationdate || null],
      planid: [data.planid || null],
      tripsqty: [data.tripsqty != null ? data.tripsqty : null],
      description: [data.description || ''],
      isltc: [data.isltc || false],
      createdon: [data.createdon || null],
      modifieddonformatted: [data.modifieddonformatted || null],
    });
  }

  private columnDefs() {
    return [
      { headerName: 'ID',
        field: 'riderpayordetailid',
        colId: 'id',
        hide: true
      },
      {
        headerName: '',
        field: 'select',
        checkboxSelection: true,
        headerCheckboxSelection: true,
        width: 30
      },
      {
        headerName: 'Plan Id',
        field: 'planid',
        width: 150
      },
      {
        headerName: 'Start Date',
        field: 'startdate',
        width: 150,
        comparator: CustomDate.dateFilter
      },
      {
        headerName: 'Expiration Date',
        field: 'expirationdate',
        width: 150,
        comparator: CustomDate.dateFilter
      },
      {
        headerName: 'Qty',
        field: 'tripsqty',
        width: 80,
        hide: true
      },
      {
        headerName: 'Created On',
        field: 'createdon',
        width: 150,
        comparator: CustomDate.dateFilter
      },
      {
        headerName: 'Modified On',
        field: 'modifiedonformatted',
        width: 150,
        comparator: CustomDate.dateFilter
      }
    ];
  }

  edit($event: any) {
    if ($event.data.riderpayordetailid) {
      this.rowIndex = $event.rowIndex;
      this.form.patchValue($event.data);
      this.add();
      this.loadTripsQty();
      this.setValues();
    }
  }

  setValues() {
    this.form.patchValue({ description: null });
    this.form.get('description').enable();
    this.file = null;
    this.fileName = null;
    this.file = new FileModel();
  }
  emitterActionCard($event: any) {
    if (!$event.isOpen) {
      this.form.patchValue(this.json);
      this.rowIndex = undefined;
    }
  }

  private valueChanges() {
    if (this.riderPayorForm.get('riderpayorid').value) {
      this.form.patchValue({riderpayorid: this.riderPayorForm.get('riderpayorid').value});
    }
    if (this.riderPayorForm.get('payorid').value) {
      this._planService.get(this.riderPayorForm.get('payorid').value).subscribe((resp) => this.selectPlan = resp);
    }
    this.subscriptions.push(
      this.riderPayorForm.get('riderpayorid').valueChanges.subscribe(val => {
        if (val) {
          this.form.patchValue({riderpayorid: val});
        }
      }),
      this.riderPayorForm.get('payorid').valueChanges.subscribe(val => {
        if (val) {
          this._planService.get(val).subscribe((resp) => this.selectPlan = resp);
        }
      }),
      this.form.get('startdate').valueChanges.subscribe(val => {
        if (Date.parse(val)) {
          this.validateDate(true);
        }
      }),
      this.form.get('expirationdate').valueChanges.subscribe(val => {
        if (Date.parse(val)) {
          this.validateDate(true);
        }
      })
    );
  }

  validateDate(msj?: boolean) {
    const startdate = Date.parse(this.form.get('startdate').value);
    const expirationdate = Date.parse(this.form.get('expirationdate').value);
    if (startdate && expirationdate) {
      if (expirationdate < startdate) {
        if (msj) {
          this.sweetAlertHelper.createCustomAlert(
            {
              title: 'The expiration date is greater than the start date',
              type: 'warning'
            });
        }
        return true;
      }
    }
    return false;
  }

  dateParse(value?) {
    return !!Date.parse(value ? value : '');
  }

  saveTripsQty(): void {
    if (this.isAllowedAction('UpdateTripsQty')) {
      if (!isNaN(this.riderPayorDetailIdCtrl.value) && this.riderPayorDetailIdCtrl.value > 0) {
        if (!isNaN(this.tripsqtyCtrl.value) && this.tripsqtyCtrl.value > 0) {
          const BODY = {
            riderpayordetailid: this.riderPayorDetailIdCtrl.value,
            tripsqty: this.tripsqtyCtrl.value,
            file: this.file
          };

          this.subscriptions.push(
            this._riderPayorDetailService.putTripsQty(BODY)
            .subscribe({
              next: (res: any) => {
                this.sweetAlertHelper.createCustomAlert({
                  title: 'Success',
                  type: 'success',
                  text: res.message
                });
              },
              error: (e) => this.sweetAlertHelper.captureException(e)
            })
          );

        } else {
          this.sweetAlertHelper.createCustomAlert({
            title: 'Error',
            type: 'error',
            text: 'You must fill in the qty field'
          });
        }
      }
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Error',
        type: 'error',
        text: 'You do not have permissions to perform this action'
      });
    }
  }

  loadTripsQty(): void {
    if (!isNaN(this.riderPayorDetailIdCtrl.value)
    && this.riderPayorDetailIdCtrl.value > 0) {
      this.subscriptions.push(
        this._riderPayorDetailService
        .getTripsQty(this.riderPayorDetailIdCtrl.value)
        .subscribe({
          next: (res: any) => {
            if (res && res.tripsqty) {
              this.tripsqtyCtrl.patchValue(res.tripsqty);
            }
          },
          error: (e) => this.sweetAlertHelper.captureException(e)
        })
      );
    }
  }

  /**
   * @name uploadFile
   * @description METHODS TO UPLOAD DOCUMENT
   */
  onAttachDocument($event: any) {
    const file = $event.target.files[0];
    const MimeType = $event.target.files[0].type;
    if (MimeType && !this.validMimeType(MimeType))  {
      this.sweetAlertHelper.captureException('The file type is invalid');
      return;
    } else if (file) {
      this.form.get('description').disable();
      this.fileName = file.name;
      const reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
      this.file.MimeType = file.type;
    }
  }
  validMimeType(mimeType: string): boolean {
    const validMimeType = [
      'application/pdf',
      'image/png',
      'image/jpeg',
      'image/jpg',
    ];
    return validMimeType.includes(mimeType);
  }
  _handleReaderLoaded(readerEvt: any) {
    const binaryString = readerEvt.target.result;
    this.file.Attachement = btoa(binaryString);
    this.file.AttachementName = this.form.get("description").value;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-payor-detail/rider-payor-detail.component.ts